import React, { useEffect, useState } from "react";
import requestApi from "../../apirest/index";
import { toast } from "react-toastify";
import Loading from "../../shared/components/Loading/Loading";
import NumberFormat from 'react-number-format';
import "./components/CostItemsTable.css";
import "./components/CostTabLayout.css";

const TotalCost = ({ onTotalCostChange, totalAmountPrototype, totalProduced, totalLogistics, productFinded, savedId }) => {
  const [amountPrototype, setAmountPrototype] = useState(0);
  const [producedQuantity, setProducedQuantity] = useState(1);
  const [product, setProduct] = useState(productFinded);
  const [totalScalingCost, setTotalScalingCost] = useState(0);
  const [price, setPrice] = useState(0);
  const [id, setId] = useState(null);
  const [loading, setLoading] = useState(false);
  const profitMargins = [10, 20, 30, 40, 50]; // Margens de lucro em %


  useEffect(() => {
    // Notifica o componente pai sobre as mudanças
    calcularValores(producedQuantity);
    console.log("CHEGOU AQUI", totalProduced, totalScalingCost, amountPrototype, totalLogistics);
    setPrice(totalProduced + totalScalingCost + amountPrototype + totalLogistics);
    if (onTotalCostChange) {
      onTotalCostChange({
        product,
        amountPrototype,
        producedQuantity,
        totalScalingCost,
        price,
        id
      });
    }
  }, [
    product,
    amountPrototype,
    producedQuantity,
    totalScalingCost,
    price,
    totalAmountPrototype,
    totalProduced,
    totalLogistics
  ]);

  const findTotalCostByProduct = async () => {
    setLoading(true);
    try {
      const idProduct = productFinded._id;
      const res = await requestApi(`/totalCost/findByIdProduct`, idProduct, "get");
      const totalCost = res?.data?.doc[0];
      console.log("chegoiu aqui prototyope", totalCost);
      setLoading(false);
      // Atualiza todos de uma vez
      if (totalCost) {
        setProduct(totalCost.product);
        setAmountPrototype(totalCost.amountPrototype);
        setProducedQuantity(totalCost.producedQuantity);
        setId(totalCost._id);
        setTotalScalingCost(totalCost.totalScalingCost);
        setPrice(totalCost.price);
      } else {
        setProduct(productFinded);
        setAmountPrototype(0);
        setProducedQuantity(1);
        setTotalScalingCost(0);
        setPrice(0);
      }
    } catch (error) {
      console.log(error);
      toast.error("Aconteceu algum erro inesperado.", {
        autoClose: 4000,
      });

      setLoading(false);
    }
  };

  useEffect((() => {
    findTotalCostByProduct();
  }), [productFinded])

  // Depois de salvar, o pai recebe o _id real do registro criado — sem
  // sincronizar de volta pro estado local, o próximo salvamento (ex: ao
  // ajustar a quantidade produzida) reportava id=null de novo, criando um
  // registro duplicado em vez de atualizar o existente.
  useEffect(() => {
    if (savedId) setId(savedId);
  }, [savedId]);



  const calcularValores = (producedQuantity) => {
    setProducedQuantity(producedQuantity)
    setAmountPrototype(totalAmountPrototype / producedQuantity);
  };

  const renderProFitMargins = () => {
    return <div className="cp-card cost-tab-card">
      <h3 className="cit-title">Calculadora de Markup</h3>

      <div className="cit-table-scroll">
        <table className="cit-table">
          <thead>
            <tr>
              <th>Markup (%)</th>
              <th>Preço de Venda (R$)</th>
            </tr>
          </thead>
          <tbody>
            {profitMargins.map((markup) => {
              const sellingPrice = price * (1 + markup / 100);
              return (
                <tr key={markup}>
                  <td>{markup}%</td>
                  <td>
                    <NumberFormat
                      value={sellingPrice}
                      displayType="text"
                      thousandSeparator="."
                      prefix="R$"
                      decimalScale={2}
                      fixedDecimalScale={true}
                      decimalSeparator=","
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  }

  const renderPrice = () => {
    return <div className="cost-tab-page">
      <div className="cp-card cost-summary-card">
        <div className="cp-field-row">
          <div className="cp-field">
            <label className="cp-label">Quantidade produzida</label>
            <input
              className="cp-input"
              type="number"
              value={producedQuantity}
              step="1"
              onChange={(e) => calcularValores(e.target.value)}
            />
          </div>

          <div className="cp-field">
            <label className="cp-label">
              Custo piloto por peça (
              <NumberFormat
                value={totalAmountPrototype}
                displayType="text"
                thousandSeparator="."
                prefix="R$"
                decimalScale={2}
                fixedDecimalScale={true}
                decimalSeparator=","
              />
              {" / "}{producedQuantity})
            </label>
            <NumberFormat
              className="cp-input"
              value={amountPrototype}
              displayType="input"
              thousandSeparator="."
              prefix="R$"
              decimalScale={2}
              fixedDecimalScale={true}
              disabled={true}
              decimalSeparator=","
            />
          </div>

          <div className="cp-field">
            <label className="cp-label">Custo produção por peça</label>
            <NumberFormat
              className="cp-input"
              value={totalProduced}
              displayType="input"
              thousandSeparator="."
              prefix="R$"
              decimalScale={2}
              fixedDecimalScale={true}
              disabled={true}
              decimalSeparator=","
            />
          </div>

          <div className="cp-field">
            <label className="cp-label">Custo logística por peça</label>
            <NumberFormat
              className="cp-input"
              value={totalLogistics}
              displayType="input"
              thousandSeparator="."
              prefix="R$"
              decimalScale={2}
              fixedDecimalScale={true}
              disabled={true}
              decimalSeparator=","
            />
          </div>

          <div className="cp-field">
            <label className="cp-label">Custo ampliação</label>
            <NumberFormat
              className="cp-input"
              value={totalScalingCost}
              displayType="input"
              thousandSeparator="."
              prefix="R$"
              decimalScale={2}
              fixedDecimalScale={true}
              onValueChange={(values) => setTotalScalingCost(values.floatValue)}
              decimalSeparator=","
            />
          </div>
        </div>
      </div>

      <div className="cost-grand-total">
        <span>Preço unitário</span>
        <strong>
          <NumberFormat
            value={price}
            displayType="text"
            thousandSeparator="."
            prefix="R$"
            decimalScale={2}
            fixedDecimalScale={true}
            decimalSeparator=","
          />
        </strong>
      </div>

      {renderProFitMargins()}

      {
        loading && <Loading overlay />
      }
    </div>;
  }



  return (
    <>
      {renderPrice()}
    </>
  );


};

export default TotalCost;


